import { render, staticRenderFns } from "./AppRodzajOferty.vue?vue&type=template&id=1af6d226&"
import script from "./AppRodzajOferty.vue?vue&type=script&lang=js&"
export * from "./AppRodzajOferty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports